import React from 'react';

function PasswordFormater(): JSX.Element {
  return <>*********</>;
}

export default PasswordFormater;
